import classNames from 'classnames'
import type { MouseEvent } from 'react'
import React, { memo } from 'react'
import { primary, TRANSITION_SIMPLE } from 'styles'
import { noop } from 'utils'

import Box from '@mui/material/Box'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles({
  dot: {
    backgroundColor: '#E7E7E9',
    borderRadius: '100%',
    height: '0.5rem',
    transition: TRANSITION_SIMPLE,
    width: '0.5rem',
  },
  selected: {
    backgroundColor: primary,
  },
  spacing: {
    marginRight: '0.5rem',
  },
})

export interface SliderDotsProps {
  className?: string
  length: number
  selected?: number
  onChange?: (index: number) => void
}

function SliderDots({ className = '', length, selected, onChange = noop }: SliderDotsProps) {
  const classes = useStyles()

  if (!length) return null

  return (
    <Box className={className} display="flex" zIndex="1">
      {Array.from({ length }, (_, index) => {
        const isUnselected = selected !== index
        const handleChange = (event: MouseEvent) => {
          event.stopPropagation()
          if (isUnselected) onChange(index)
        }

        return (
          <Box
            key={index}
            onClick={handleChange}
            className={classNames({ 'cursor-pointer': isUnselected && onChange !== noop })}
            p="0.25rem"
          >
            <Box className={classNames(classes.dot, { [classes.selected]: index === selected })} />
          </Box>
        )
      })}
    </Box>
  )
}

export default memo(SliderDots)
